import React, {Component} from 'react'
import {Col, Form } from 'react-bootstrap'
import { SIZE_COLUMN } from '../config/constants/various';
import { withTranslation } from "react-i18next";

class inputBox extends Component {
  constructor(props) {
    super(props);
  }

  generateOptions() {
    const { t } = this.props;
    const element = this.props.options.map(item => {
      return (
        <option
          key={item.id}
          value={item.id}
          >{t(item.name)}</option>
      )
    })
    return element;
  }

  render() {
    const isValid = this.props.errors.find(e => e.id === this.props.id)
      ? false : true;
    const sizeColumn = this.props.sizeColumn || SIZE_COLUMN;
    const { t } = this.props;
    return (
      <Col className="col-12 check mb-4" sm={sizeColumn}>
        <Form.Group>
          <Form.Label htmlFor="select1">{t(this.props.label)}</Form.Label>
          <Form.Control as="select"
                        name={this.props.id}
                        onChange={this.props.handleChange}
                        {...(isValid) ? { isValid: true } : { isInvalid: true }}
                        value={this.props.value}>
            <option disabled={(this.props.value !== "") ? true : false} selected>{t(this.props.placeholder) || `${t("translation:form>enter")} ${t(this.props.label)}`}</option>
            {this.generateOptions()}
          </Form.Control>
          {isValid ? "" : <Form.Control.Feedback type="invalid">{t(this.props.placeholder) || `${t("translation:form>enter")} ${t(this.props.label)}`}</Form.Control.Feedback>}
        </Form.Group>
      </Col>
    )
  }
}

export default (withTranslation()(inputBox));
